export const CONTENT_STATUS = {
  DRAFT: 'DRAFT',
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
  SCHEDULED: 'SCHEDULED',
  PUBLISHED: 'PUBLISHED',
};

const CONTENT_STATUS_OPTIONS = [
  { value: CONTENT_STATUS.DRAFT, label: 'Draft' },
  { value: CONTENT_STATUS.IN_REVIEW, label: 'In Review' },
  { value: CONTENT_STATUS.APPROVED, label: 'Approved' },
  { value: CONTENT_STATUS.SCHEDULED, label: 'Scheduled' },
  { value: CONTENT_STATUS.PUBLISHED, label: 'Published' },
];

const NON_SCHEDULABLE_CONTENT_TYPE_NAMES = ['Facebook Ads', 'Google Ads'];

const normalizeName = (value) =>
  typeof value === 'string' ? value.trim().toLowerCase() : '';

const isNonSchedulableName = (value) => {
  const normalized = normalizeName(value);
  if (!normalized) return false;
  return NON_SCHEDULABLE_CONTENT_TYPE_NAMES.some(
    (name) => normalizeName(name) === normalized
  );
};

export const isSchedulableContentType = (contentTypeName, parentContentType) =>
  !isNonSchedulableName(contentTypeName) && !isNonSchedulableName(parentContentType);

export const getContentStatusFilterOptions = () => CONTENT_STATUS_OPTIONS;

export const getContentStatusLabel = (status) => {
  switch (status) {
    case CONTENT_STATUS.IN_REVIEW:
      return 'In Review';
    case CONTENT_STATUS.APPROVED:
      return 'Approved';
    case CONTENT_STATUS.SCHEDULED:
      return 'Scheduled';
    case CONTENT_STATUS.PUBLISHED:
      return 'Published';
    case CONTENT_STATUS.DRAFT:
    default:
      return 'Draft';
  }
};

export const resolveContentStatus = (status, isPublished, isScheduled) => {
  if (isPublished) {
    return CONTENT_STATUS.PUBLISHED;
  }
  if (isScheduled) {
    return CONTENT_STATUS.SCHEDULED;
  }
  if (!status) {
    return CONTENT_STATUS.DRAFT;
  }
  return status;
};
